import { auth } from "@/lib/firebaseClient";
import { sendUserEmailVerification } from "@/services/auth";
import { useEffect, useState } from "react";
import Modal from "../Modal/Modal";
import ButtonSecondary from "../buttons/ButtonSecondary/ButtonSecondary";
import styles from "./EmailVerificationModal.module.scss";
import { useAuth } from "@/context/AuthContext";
import { LogoutIcon } from "../icons/logout";

const EMAIL_VERIFICATION_RETRY_LIMIT = 100;
const EMAIL_VERIFICATION_RETRY_INITIAL_DELAY = 5000;
const EMAIL_VERIFICATION_RETRY_DELAY_BACKOFF_RATE = 1250;
const EMAIL_VERIFICATION_RESEND_DELAY = 30000;

const EmailVerificationModal = () => {
  const [showEmailVerificationModal, setShowEmailVerificationModal] =
    useState(false);
  const [emailVerificationRetryCount, setEmailVerificationRetryCount] =
    useState(0);
  const [didResendEmailVerification, setDidResendEmailVerification] =
    useState(false);

  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    const checkEmailVerification = async () => {
      const isUserAuthenticated = Boolean(auth.currentUser);
      const isEmailVerified =
        isUserAuthenticated && auth.currentUser?.emailVerified;
      setShowEmailVerificationModal(isUserAuthenticated && !isEmailVerified);
      if (emailVerificationRetryCount >= EMAIL_VERIFICATION_RETRY_LIMIT) return;
      if (!isUserAuthenticated || !isEmailVerified) {
        setTimeout(async () => {
          if (auth.currentUser) {
            await auth.currentUser.reload();
          }
          setEmailVerificationRetryCount(emailVerificationRetryCount + 1);
        }, EMAIL_VERIFICATION_RETRY_INITIAL_DELAY + EMAIL_VERIFICATION_RETRY_DELAY_BACKOFF_RATE * emailVerificationRetryCount);
      }
    };
    checkEmailVerification();
  }, [emailVerificationRetryCount]);

  const resendEmailVerification = () => {
    if (!auth.currentUser) return;
    if (didResendEmailVerification) return;
    sendUserEmailVerification(auth.currentUser);
    setDidResendEmailVerification(true);
    setTimeout(() => {
      setDidResendEmailVerification(false);
    }, EMAIL_VERIFICATION_RESEND_DELAY);
  };

  return (
    <Modal
      showHeader={true}
      hideCloseButton={true}
      headerContent={
        <div className={styles.emailVerificationModalHeader}>
          <h2 className="headline-4">Verify Email</h2>
        </div>
      }
      width={"auto"}
      height={"auto"}
      isOpen={showEmailVerificationModal}
    >
      <div className={styles.emailVerificationModalContent}>
        <p>
          In order to start using Skin Generator, please click the verification
          link in your email inbox.
        </p>
        <p>
          Can't find an email from us? Click the button below to send another
          verification email:
        </p>
        <ButtonSecondary
          className={`${styles.emailVerificationModalButton} ${didResendEmailVerification &&
            styles.emailVerificationModalButtonDisabled
            }`}
          onClick={resendEmailVerification}
          loading={false}
          disabled={didResendEmailVerification}
          text={
            didResendEmailVerification
              ? "Verification email sent!"
              : "Re-send verification email"
          }
        />
        <p>
          Need to log in to a different account? Click the button below to log
          out:
        </p>
        <ButtonSecondary
          className={styles.emailVerificationModalButton}
          onClick={handleLogout}
          loading={false}
          icon={<LogoutIcon width={"16"} height={"16"} color={"#B3005E"} />}
          text="Switch accounts"
        />
      </div>
    </Modal>
  );
};

export default EmailVerificationModal;
